<template>
  <div class="row custom-field">
    <div class=col-sm-3>
      {{field.name}}
    </div>
    <div class="col-sm-3">
      <b-form-input v-if="field.field_type === 'String'" type="text"
        v-model="fieldValue"></b-form-input>
      <b-form-input v-if="field.field_type === 'Number'" type="number"
        v-model="fieldValue"></b-form-input>
      <b-form-checkbox v-if="field.field_type === 'Checkbox'" v-model="fieldValue" value="true" unchecked-value="false">
      </b-form-checkbox>
      <b-form-textarea v-if="field.field_type === 'Text'" type="text" v-model="fieldValue">
      </b-form-textarea>
      <datepicker v-if="field.field_type === 'Date'" v-model="fieldValue"/>
    </div>
  </div>
</template>
<script>
import {mapMutations} from 'vuex'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'ClientField',
  props: ['field', 'client'],
  data () {
    return {
      inputTypes: ['String', 'Checkbox', 'Number', 'Text', 'Date'],
      fieldObject: {},
      fieldValue: null
    }
  },
  components: {
    Datepicker
  },
  created () {
    this.fieldValue = this.client.custom_fields[this.field.name]
  },

  methods: {
    ...mapMutations(['updateCustomField'])
  },

  watch: {
    fieldValue: function (val) {
      this.updateCustomField({name: this.field.name, value: val})
    }
  }
}
</script>
<style scoped>
.custom_fields{
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ClientField.vue